import { render, staticRenderFns } from "./ProductoShowData.vue?vue&type=template&id=40c89702"
import script from "./ProductoShowData.vue?vue&type=script&lang=js"
export * from "./ProductoShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports